import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetEmployeesQuery = ({
  limit,
  offset,
  nameContains,
  isActive,
}: {
  offset: number;
  limit: number;
  nameContains?: string;
  isActive?: boolean;
}) => {
  return useQuery({
    queryKey: ['getUsers', limit, offset, nameContains, isActive],
    queryFn: () => Api.users.getUsers({ limit, offset, name__contains: nameContains, is_active: isActive }),
  });
};
